import axios from 'axios';
import store from '@/store';
import router from '@/router';

import { AUTH_LOGOUT } from '@/store/actions/auth';
import { ROUTE_LOGIN } from '@/constants/routes';

axios.defaults.withCredentials = true;

const instance = axios.create();

// instance.defaults.headers.post['Content-Type'] = 'application/json';
instance.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

instance.interceptors.request.use(
  (request) => request,
  (error) => Promise.reject(error)
);

instance.interceptors.response.use(
  (response) => response,
  (error) => {
    const { status } = error.response;
    const { isAuthenticated } = store.getters;

    if (isAuthenticated && status === 401) {
      store.commit(AUTH_LOGOUT);
      router.push(ROUTE_LOGIN + '?logout=true');
    }

    return Promise.reject(error);
  }
);

export default instance;
